import { render, staticRenderFns } from "./ResponsibleTodos.vue?vue&type=template&id=b7de03b8&scoped=true&"
import script from "./ResponsibleTodos.vue?vue&type=script&lang=ts&"
export * from "./ResponsibleTodos.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7de03b8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VListItem } from 'vuetify/lib/components/VList';
installComponents(component, {VBtn,VChip,VListItem})
